module.exports = __webpack_public_path__ + "static/img/platform-name-l.cdfb5dfa.png";